import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=28473bb4&"
import script from "./Paper.vue?vue&type=script&lang=js&"
export * from "./Paper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports